import { useRef } from 'react';
import { useConfigState } from "../../hooks";
import { useTranslation } from "react-i18next";
import CreatableSelect from 'react-select/creatable';
import { databaseNamespaceOptions, IOptionType } from '../../types/common';
import { FormLabel } from 'react-bootstrap';

const DatabaseNamespace = () => {
    const { t } = useTranslation()
    const { setDatabaseNamespaces, databaseNamespaces } = useConfigState()


    return (
        <>
        <FormLabel>{t("Filter.defaultImageType")}:</FormLabel>
            <CreatableSelect
                    className="card border-0"
                    closeMenuOnSelect={true}
                    options={databaseNamespaceOptions}
                    onChange={(selectedOption) => setDatabaseNamespaces(selectedOption as IOptionType)}
                    value={databaseNamespaces}
                    placeholder={t("Filter.imageType")}
                />
                <br></br>
        </>
    )
}

export default DatabaseNamespace